import Http from '@/services/http';
import translate from '@/services/translate';
import {
  AlarmHistoryRequest,
  AlarmHistoryResponse,
  AlarmsReportListRequest,
  AlarmsTemplateListResponse,
  InsertAlarmTemplateRequest,
  GetAlarmTemplateResponse,
} from 'sigma-mappings';

const urls = {
  history: '/Alarme/historico',
  exportHistoryExcel: '/Alarme/historico/exportar/excel',
  templateList: '/Alarme/template/listagem',
  removeTemplate: id => `/Alarme/${id}`,
  insertTemplate: '/Alarme/template',
  getTemplateById: id => `/Alarme/template/${id}`,
  updateTemplate: id => `/Alarme/template/${id}`,
};

const fields = {
  DataInicial: {
    name: 'fields.general.initial-date',
  },
  DataFinal: {
    name: 'fields.general.final-date',
  },
};

/* istanbul ignore next */
const errorHandler = {
  errorHandling: {
    responseMessageParams: {
      $MA001: ({ field }) => {
        const returnedField = fields[field];
        if (!returnedField) return null;
        return {
          NomeDoCampo: translate(returnedField.name),
        };
      },
      $MA009: data => data,
      $MA019: data => data,
      $ME090: (data) => ({ 0: data.parameters[0] }),
      $ME091: (data) => ({ 0: data.parameters[0] }),
    },
  },
};

export default {
  getAlarmHistory(payload) {
    const mappedPayload = new AlarmHistoryRequest(payload);
    const http = new Http(errorHandler);
    return http
      .post(urls.history, mappedPayload)
      .then(({ data }) => new AlarmHistoryResponse(data));
  },
  exportHistoryExcel(payload) {
    const mappedPayload = new AlarmHistoryRequest(payload);
    const http = new Http({
      download: true,
      ...errorHandler,
    });
    return http
      .post(urls.exportHistoryExcel, mappedPayload)
      .then(({ data }) => data);
  },
  getTemplateList(payload) {
    const http = new Http();
    const mappedPayload = new AlarmsReportListRequest(payload);
    return http
      .post(urls.templateList, mappedPayload)
      .then(({ data }) => new AlarmsTemplateListResponse(data));
  },
  removeTemplate(reportId) {
    const http = new Http();
    return http.delete(urls.removeTemplate(reportId))
      .then(({ status }) => status === 200);
  },

  /**
   * Insere um template de relatório de histórico de dados
   */
  insertTemplate(params) {
    const http = new Http(errorHandler);
    const mappedParams = new InsertAlarmTemplateRequest(params);

    return http.post(urls.insertTemplate, mappedParams)
    .then(({ data }) => data);
  },
  /**
   * Altera um template de relatório de histórico de dados
   */
  updateTemplate(templateId, params) {
    const http = new Http(errorHandler);
    return http.put(urls.updateTemplate(templateId), new InsertAlarmTemplateRequest(params));
  },

  getTemplateById(templateId) {
    const http = new Http(errorHandler);

    return http.get(urls.getTemplateById(templateId))
      .then(({ data }) => new GetAlarmTemplateResponse(data));
  },
};
